import brownie from '../Assets/Recipes/brownie.jpg'
import lentilha from '../Assets/Recipes/lentilha.jpg'
import omelete from '../Assets/Recipes/omelete.jpg'
import salada from '../Assets/Recipes/salada.jpg'
import bico from '../Assets/Recipes/bico.jpg'
import torta from '../Assets/Recipes/torta.jpg'
import wrapHumus from '../Assets/Recipes/wrapHumus.jpg'
import Atum from '../Assets/Recipes/atum.jpg'
import sopa from '../Assets/Recipes/sopa.jpg'
import abobora from '../Assets/Recipes/abobora.jpg'
import bolo from '../Assets/Recipes/bolo.jpg'
import acai from '../Assets/Recipes/acai.jpg'
export const recipes = [
    {
      id: 1,
      title: "Smoothie Bowl de Frutas Vermelhas",
      description: "Uma opção refrescante e nutritiva para o café da manhã.",
      image: "https://img.freepik.com/free-photo/ceramic-bowl-delicious-acai-brazilian-dessert_23-2149788549.jpg?t=st=1738266846~exp=1738270446~hmac=60482830075b4882866109849f78942f0f0d5ee20863dbf4047f06964fa031c5&w=360",
      categories: ["Todas", "Baixa Caloria", "Vegetariana", "Vegana"],
      ingredients: [
        "1 xícara de frutas vermelhas congeladas",
        "1 banana congelada",
        "1/2 xícara de leite vegetal",
        "1 colher de mel ou xarope de ácer",
        "Granola para decorar",
        "Frutas frescas para decorar",
      ],
      instructions: [
        "No liquidificador, bata as frutas vermelhas, banana e leite até obter uma consistência cremosa.",
        "Transfira para uma tigela.",
        "Decore com granola e frutas frescas.",
        "Sirva imediatamente.",
      ],
      prepTime: "10 minutos",
    },
    {
      id: 2,
      title: "Bowl de Quinoa com Frango",
      description: "Refeição nutritiva rica em proteínas.",
      image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?auto=format&fit=crop&q=80&w=2080",
      categories: ["Todas", "Rica em Proteina"],
      ingredients: [
        "200g de peito de frango",
        "1 xícara de quinoa",
        "Mix de legumes",
        "Azeite de oliva",
        "Temperos a gosto",
      ],
      instructions: [
        "Cozinhe a quinoa conforme instruções.",
        "Grelhe o frango temperado.",
        "Monte o bowl com quinoa, frango e legumes.",
        "Finalize com azeite.",
      ],
      prepTime: "25 minutos",
    },
    {
      id: 3,
      title: "Brownie de Batata Doce",
      description: "Sobremesa saudável e deliciosa.",
      image: brownie,
      categories: ["Todas", "Sobremesa Fit", "Sem Glúten"],
      ingredients: [
        "2 batatas doces médias",
        "1/2 xícara de cacau em pó",
        "3 ovos",
        "Mel a gosto",
        "Essência de baunilha",
      ],
      instructions: [
        "Cozinhe e amasse as batatas.",
        "Misture com os demais ingredientes.",
        "Coloque em forma untada.",
        "Asse por 25 minutos.",
      ],
      prepTime: "40 minutos",
    },
    {
      id: 4,
      title: "Bolinho de Arroz Integral",
      description: "Aperitivo saudável e saboroso.",
      image: "https://img.freepik.com/free-photo/top-view-tasty-fried-cutlets-with-cooked-rice-dark-surface-rissole-meat-dish_140725-82654.jpg?t=st=1738268271~exp=1738271871~hmac=adbfd4ee47d9953127c84a41326c98891c633204e2bf4113200f3c3c431386f1&w=996",
      categories: ["Todas", "Vegetariana", "Sem Glúten"],
      ingredients: [
        "2 xícaras de arroz integral cozido",
        "1 ovo",
        "1/4 xícara de queijo parmesão ralado",
        "Salsinha picada",
        "Sal e pimenta a gosto",
      ],
      instructions: [
        "Misture todos os ingredientes.",
        "Forme bolinhos.",
        "Frite em óleo quente ou asse no forno.",
        "Sirva quente.",
      ],
      prepTime: "30 minutos",
    },
    {
      id: 5,
      title: "Salada de Frutas com Iogurte",
      description: "Sobremesa refrescante e nutritiva.",
      image: "https://img.freepik.com/free-photo/fruit-salad-with-yoghurt_144627-34422.jpg?t=st=1738267091~exp=1738270691~hmac=fba01556b3b883d26d95fce9f4cb470679c5d89531519091292d4c2e1c488259&w=360",
      categories: ["Todas", "Baixa Caloria", "Vegetariana"],
      ingredients: ["Mix de frutas da estação", "Iogurte natural", "Granola", "Mel", "Hortelã para decorar"],
      instructions: [
        "Corte as frutas em pedaços.",
        "Misture com o iogurte natural.",
        "Adicione granola por cima.",
        "Regue com mel.",
        "Decore com folhas de hortelã.",
      ],
      prepTime: "10 minutos",
    },
    {
      id: 6,
      title: "Hambúrguer de Grão-de-Bico",
      description: "Opção vegetariana rica em proteínas.",
      image: bico,
      categories: ["Todas", "Vegetariana", "Vegana", "Rica em Proteina"],
      ingredients: [
        "2 xícaras de grão-de-bico cozido",
        "1/2 cebola picada",
        "2 dentes de alho",
        "1/4 xícara de farinha de aveia",
        "Temperos a gosto",
      ],
      instructions: [
        "Processe o grão-de-bico com cebola e alho.",
        "Adicione a farinha de aveia e temperos.",
        "Forme hambúrgueres.",
        "Grelhe ou asse até dourar.",
      ],
      prepTime: "25 minutos",
    },
    {
      id: 7,
      title: "Pudim de Chia com Frutas",
      description: "Sobremesa nutritiva e fácil de preparar.",
      image: "https://img.freepik.com/free-photo/top-view-homemade-breakfast-with-kiwi_23-2148566887.jpg?t=st=1738268201~exp=1738271801~hmac=dbdfd9d77b2bd6a449edebf2a25837b56f64b08c04",
      categories: ["Todas", "Sobremesa Fit", "Vegetariana", "Vegana", "Sem Glúten"],
      ingredients: [
        "1/4 xícara de sementes de chia",
        "1 xícara de leite vegetal",
        "1 colher de sopa de mel ou xarope de bordo",
        "Essência de baunilha",
        "Frutas frescas para decorar",
      ],
      instructions: [
        "Misture a chia com o leite vegetal, mel e baunilha.",
        "Deixe na geladeira por pelo menos 4 horas ou durante a noite.",
        "Antes de servir, decore com frutas frescas.",
        "Sirva gelado.",
      ],
      prepTime: "5 minutos + 4 horas de geladeira",
    },
    {
      id: 8,
      title: "Torta de Frango Fit",
      description: "Versão saudável da clássica torta de frango.",
      image: torta,
      categories: ["Todas", "Rica em Proteina", "Baixa Caloria"],
      ingredients: [
        "2 xícaras de frango cozido e desfiado",
        "1 xícara de farinha de aveia",
        "2 ovos",
        "1/2 xícara de iogurte natural",
        "Legumes picados (cenoura, ervilha, milho)",
      ],
      instructions: [
        "Misture a farinha de aveia, ovos e iogurte para a massa.",
        "Forre uma forma com metade da massa.",
        "Adicione o recheio de frango e legumes.",
        "Cubra com o restante da massa e asse por 30 minutos.",
      ],
      prepTime: "45 minutos",
    },
    {
      id: 9,
      title: "Salada de Quinoa com Manga e Hortelã",
      description: "Salada refrescante e cheia de sabor.",
      image: 'https://images.unsplash.com/photo-1511690743698-d9d85f2fbf38',
      categories: ["Todas", "Vegetariana", "Vegana", "Sem Glúten"],
      ingredients: [
        "1 xícara de quinoa cozida",
        "1 manga madura em cubos",
        "1/4 xícara de hortelã fresca picada",
        "1/4 xícara de amêndoas laminadas",
        "Suco de limão",
        "Azeite de oliva",
      ],
      instructions: [
        "Misture a quinoa cozida com a manga e hortelã.",
        "Adicione as amêndoas laminadas.",
        "Tempere com suco de limão e azeite.",
        "Sirva frio ou em temperatura ambiente.",
      ],
      prepTime: "15 minutos",
    },
    {
      id: 10,
      title: "Wrap de Atum com Abacate",
      description: "Lanche rápido e nutritivo.",
      image: Atum,
      categories: ["Todas", "Rica em Proteina", "Baixa Caloria"],
      ingredients: [
        "1 tortilha integral",
        "1 lata de atum em água",
        "1/2 abacate",
        "Folhas verdes",
        "Tomate em rodelas",
      ],
      instructions: [
        "Escorra o atum e misture com o abacate amassado.",
        "Espalhe a mistura na tortilha.",
        "Adicione as folhas verdes e tomate.",
        "Enrole e sirva.",
      ],
      prepTime: "10 minutos",
    },
    {
      id: 11,
      title: "Panquecas de Banana e Aveia",
      description: "Café da manhã saudável e delicioso.",
      image: "https://img.freepik.com/free-photo/almond-banana-pancake_1339-5266.jpg?t=st=1738268789~exp=1738272389~hmac=88100e7b5f0412d6902769f0e5db1f6707a8f9711b61f96ad96e73f0dfa930a2&w=900",
      categories: ["Todas", "Vegetariana", "Sem Glúten"],
      ingredients: [
        "1 banana madura",
        "2 ovos",
        "1/2 xícara de aveia em flocos",
        "Canela a gosto",
        "Óleo de coco para untar",
      ],
      instructions: [
        "Amasse a banana e misture com os ovos e a aveia.",
        "Adicione canela a gosto.",
        "Aqueça uma frigideira com óleo de coco.",
        "Despeje pequenas porções da massa e cozinhe dos dois lados.",
      ],
      prepTime: "15 minutos",
    },
    {
      id: 12,
      title: "Sopa de Legumes com Frango",
      description: "Refeição reconfortante e nutritiva.",
      image: sopa,
      categories: ["Todas", "Rica em Proteina", "Baixa Caloria"],
      ingredients: [
        "Peito de frango em cubos",
        "Mix de legumes (cenoura, abobrinha, brócolis)",
        "Cebola e alho",
        "Caldo de galinha",
        "Temperos a gosto",
      ],
      instructions: [
        "Refogue cebola e alho.",
        "Adicione o frango e cozinhe.",
        "Acrescente os legumes e o caldo.",
        "Cozinhe até os legumes ficarem macios.",
      ],
      prepTime: "30 minutos",
    },
    {
      id: 13,
      title: "Muffins de Espinafre e Queijo Feta",
      description: "Lanche saudável e prático.",
      image: "https://img.freepik.com/free-photo/mini-pies-made-eggs-green-onions-breakfast_181624-25426.jpg?t=st=1738268941~exp=1738272541~hmac=116fcb186cbef16e79dbf68fcdb937c1d4928822736e4be0c455a26b66e573e8&w=360",
      categories: ["Todas", "Vegetariana", "Rica em Proteina"],
      ingredients: [
        "2 xícaras de farinha integral",
        "2 ovos",
        "1 xícara de espinafre picado",
        "100g de queijo feta",
        "1/2 xícara de leite",
      ],
      instructions: [
        "Misture os ingredientes secos.",
        "Adicione os ovos, leite, espinafre e queijo feta.",
        "Distribua em forminhas de muffin.",
        "Asse por 20-25 minutos a 180°C.",
      ],
      prepTime: "35 minutos",
    },
    {
      id: 14,
      title: "Salada de Lentilha com Vegetais Assados",
      description: "Refeição completa e rica em fibras.",
      image: lentilha,
      categories: ["Todas", "Vegetariana", "Vegana", "Rica em Proteina"],
      ingredients: [
        "1 xícara de lentilhas cozidas",
        "Mix de vegetais para assar (abóbora, cenoura, pimentão)",
        "Rúcula",
        "Azeite e limão para temperar",
      ],
      instructions: [
        "Asse os vegetais temperados no forno.",
        "Misture as lentilhas cozidas com os vegetais assados.",
        "Adicione rúcula fresca.",
        "Tempere com azeite e limão.",
      ],
      prepTime: "40 minutos",
    },
    {
      id: 15,
      title: "Smoothie Verde Energético",
      description: "Bebida nutritiva para começar o dia.",
      image: "https://img.freepik.com/free-photo/fresh-green-smoothie-with-banana-spinach-with-heart-sesame-seeds-love-healthy-raw-food-concept_501050-104.jpg?t=st=1738269069~exp=1738272669~hmac=142fe16d3cdc6ae81ddd17b46d22d29a4a7571784d367e42ec84eacb158f0981&w=360",
      categories: ["Todas", "Baixa Caloria", "Vegetariana", "Vegana"],
      ingredients: [
        "1 banana",
        "1 punhado de espinafre",
        "1/2 abacate",
        "1 colher de sopa de sementes de chia",
        "1 copo de leite de amêndoas",
        "Mel a gosto",
      ],
      instructions: [
        "Coloque todos os ingredientes no liquidificador.",
        "Bata até obter uma consistência cremosa.",
        "Adicione gelo se desejar.",
        "Sirva imediatamente.",
      ],
      prepTime: "5 minutos",
    },
    {
      id: 16,
      title: "Omelete de Claras com Espinafre",
      description: "Café da manhã rico em proteínas e baixo em gordura.",
      image: omelete,
      categories: ["Todas", "Rica em Proteina", "Baixa Caloria"],
      ingredients: [
        "3 claras de ovo",
        "1 punhado de espinafre picado",
        "1 colher de sopa de queijo cottage",
        "Sal e pimenta a gosto",
      ],
      instructions: [
        "Bata as claras com sal e pimenta.",
        "Despeje na frigideira antiaderente quente.",
        "Adicione o espinafre e o queijo cottage.",
        "Dobre ao meio quando estiver firme.",
      ],
      prepTime: "10 minutos",
    },
    {
      id: 17,
      title: "Salada de Grão-de-Bico Mediterrânea",
      description: "Salada refrescante e rica em fibras.",
      image: salada,
      categories: ["Todas", "Vegetariana", "Vegana", "Rica em Proteina"],
      ingredients: [
        "1 lata de grão-de-bico",
        "1/2 pepino picado",
        "1/2 cebola roxa picada",
        "Tomates cereja cortados ao meio",
        "Azeitonas pretas",
        "Azeite e suco de limão para temperar",
      ],
      instructions: [
        "Escorra e enxágue o grão-de-bico.",
        "Misture com os vegetais picados.",
        "Adicione as azeitonas.",
        "Tempere com azeite e suco de limão.",
      ],
      prepTime: "15 minutos",
    },
    {
      id: 18,
      title: "Bowl de Açaí",
      description: "Sobremesa gelada e nutritiva.",
      image: acai,
      categories: ["Todas", "Vegetariana", "Vegana", "Sem Glúten"],
      ingredients: [
        "200g de polpa de açaí congelada",
        "1 banana",
        "Granola",
        "Frutas variadas para decorar",
        "Mel (opcional)",
      ],
      instructions: [
        "Bata o açaí com a banana no liquidificador.",
        "Transfira para uma tigela.",
        "Decore com granola e frutas.",
        "Adicione mel se desejar.",
      ],
      prepTime: "10 minutos",
    },
    {
      id: 19,
      title: "Wrap de Frango com Abacate",
      description: "Almoço rápido e nutritivo.",
      image: "https://img.freepik.com/free-photo/chicken-wrap_144627-33302.jpg?t=st=1738269345~exp=1738272945~hmac=a7c8b34ecec717edfe77dc94fb759182a0415461f8f56b8f5e4c11fa65304dbd&w=360",
      categories: ["Todas", "Rica em Proteina"],
      ingredients: [
        "1 tortilha integral",
        "100g de peito de frango grelhado",
        "1/2 abacate",
        "Alface",
        "Tomate em rodelas",
      ],
      instructions: [
        "Grelhe o frango e corte em tiras.",
        "Amasse o abacate e espalhe na tortilha.",
        "Adicione o frango, alface e tomate.",
        "Enrole e sirva.",
      ],
      prepTime: "15 minutos",
    },
    {
      id: 20,
      title: "Bolo de Banana sem Açúcar",
      description: "Sobremesa saudável e deliciosa.",
      image: bolo,
      categories: ["Todas", "Sobremesa Fit", "Sem Glúten"],
      ingredients: [
        "3 bananas maduras",
        "2 ovos",
        "2 xícaras de farinha de aveia",
        "1/4 xícara de óleo de coco",
        "1 colher de chá de canela",
        "1 colher de chá de fermento em pó",
      ],
      instructions: [
        "Amasse as bananas e misture com os ovos e óleo.",
        "Adicione os ingredientes secos e misture bem.",
        "Despeje em uma forma untada.",
        "Asse por 30-35 minutos a 180°C.",
      ],
      prepTime: "45 minutos",
    },
      {
        id: 22,
        title: "Sopa de Abóbora com Gengibre",
        description: "Sopa cremosa e reconfortante.",
        image: abobora,
        categories: ["Todas", "Vegetariana", "Vegana", "Baixa Caloria"],
        ingredients: [
          "1 abóbora média cortada em cubos",
          "1 cebola picada",
          "2 dentes de alho",
          "1 pedaço de gengibre fresco",
          "Caldo de legumes",
          "Leite de coco (opcional)",
        ],
        instructions: [
          "Refogue a cebola, alho e gengibre.",
          "Adicione a abóbora e o caldo de legumes.",
          "Cozinhe até a abóbora ficar macia.",
          "Bata no liquidificador e adicione leite de coco se desejar.",
        ],
        prepTime: "35 minutos",
      },
      {
        id: 23,
        title: "Pão de Banana Integral",
        description: "Pão caseiro saudável e saboroso.",
        image: "https://img.freepik.com/free-photo/close-up-banana-bread_23-2151005934.jpg?t=st=1738269602~exp=1738273202~hmac=b406c3c9aa2e76b8498f22c298e645129c596217da826a9a3202bcc0113b1091&w=360",
        categories: ["Todas", "Vegetariana", "Sobremesa Fit"],
        ingredients: [
          "3 bananas maduras amassadas",
          "1/3 xícara de mel",
          "1/4 xícara de óleo de coco",
          "2 ovos",
          "1 3/4 xícara de farinha integral",
          "1 colher de chá de fermento em pó",
        ],
        instructions: [
          "Misture os ingredientes úmidos.",
          "Incorpore os ingredientes secos.",
          "Despeje em uma forma untada.",
          "Asse por 50-60 minutos a 180°C.",
        ],
        prepTime: "1 hora e 10 minutos",
      },

      {
        id: 25,
        title: "Overnight Oats com Frutas",
        description: "Café da manhã prático e nutritivo.",
        image: "https://img.freepik.com/free-photo/healthy-oatmeal-recipe-with-fruits-nuts_53876-124355.jpg?t=st=1738269725~exp=1738273325~hmac=40e4d2558c23a65791e297ef988b00531deda06af662aaa5cbb34a7aa4702f95&w=360",
        categories: ["Todas", "Vegetariana", "Sem Glúten"],
        ingredients: [
          "1/2 xícara de aveia em flocos",
          "1/2 xícara de leite vegetal",
          "1/4 xícara de iogurte grego",
          "1 colher de chá de chia",
          "Mel a gosto",
          "Frutas frescas para decorar",
        ],
        instructions: [
          "Misture a aveia, leite, iogurte e chia.",
          "Adicione mel a gosto.",
          "Deixe na geladeira durante a noite.",
          "Pela manhã, decore com frutas frescas.",
        ],
        prepTime: "5 minutos + tempo de geladeira",
      },
      {
        id: 26,
        title: "Wrap de Hummus e Vegetais",
        description: "Lanche vegetariano rápido e saudável.",
        image: wrapHumus,
        categories: ["Todas", "Vegetariana", "Vegana"],
        ingredients: [
          "1 tortilha integral",
          "2 colheres de sopa de hummus",
          "Mix de vegetais (pepino, cenoura ralada, tomate)",
          "Folhas de alface",
        ],
        instructions: [
          "Espalhe o hummus na tortilha.",
          "Adicione os vegetais e as folhas de alface.",
          "Enrole cuidadosamente.",
          "Corte ao meio e sirva.",
        ],
        prepTime: "10 minutos",
      },
      {
        id: 27,
        title: "Smoothie de Manga e Cúrcuma",
        description: "Bebida refrescante e anti-inflamatória.",
        image: "https://img.freepik.com/free-photo/delicious-indian-mango-drink-high-angle_23-2148734680.jpg?t=st=1738269844~exp=1738273444~hmac=56e9c070455b72ffbf99421e51f622c5d3e3e097380cf66caa2cf4f99f8ba6f7&w=360",
        categories: ["Todas", "Vegetariana", "Vegana", "Sem Glúten"],
        ingredients: [
          "1 manga madura",
          "1 banana congelada",
          "1 colher de chá de cúrcuma em pó",
          "1 copo de leite de coco",
          "1 colher de sopa de mel (opcional)",
        ],
        instructions: [
          "Descasque e corte a manga.",
          "Coloque todos os ingredientes no liquidificador.",
          "Bata até ficar cremoso.",
          "Sirva imediatamente.",
        ],
        prepTime: "5 minutos",
      },
      {
        id: 29,
        title: "Muffins de Maçã e Canela",
        description: "Muffins saudáveis para o lanche.",
        image: "https://img.freepik.com/free-photo/fruit-muffins-with-nutmeg-allspice-wicker-basket-wooden-table_2829-20082.jpg?t=st=1738269901~exp=1738273501~hmac=0038aaad2a12626476fc79e16aff5013a5e96b9cca04e143011d67846eb53635&w=826",
        categories: ["Todas", "Vegetariana", "Sobremesa Fit"],
        ingredients: [
          "2 xícaras de farinha integral",
          "2 maçãs picadas",
          "1/2 xícara de mel",
          "1/3 xícara de óleo de coco",
          "2 ovos",
          "1 colher de sopa de canela",
          "1 colher de chá de fermento em pó",
        ],
        instructions: [
          "Misture os ingredientes secos.",
          "Em outro recipiente, misture os ingredientes úmidos.",
          "Combine as duas misturas e adicione as maçãs.",
          "Distribua em forminhas e asse por 20-25 minutos a 180°C.",
        ],
        prepTime: "35 minutos",
      },
      {
        id: 30,
        title: "Bowl de Tofu Teriyaki",
        description: "Refeição asiática vegetariana.",
        image: "https://img.freepik.com/free-photo/japanese-food-bowl-rice-boiled-white-fish-wakame-chuka-seaweed-salad_2829-17359.jpg?t=st=1738269952~exp=1738273552~hmac=6e5a6e7b552f59f3b347f6dec2e7b29824d313da156249c4e13b90119a160a83&w=826",
        categories: ["Todas", "Vegetariana", "Vegana", "Rica em Proteina"],
        ingredients: [
          "1 bloco de tofu firme",
          "1/4 xícara de molho teriyaki",
          "2 xícaras de arroz integral cozido",
          "Mix de legumes (brócolis, cenoura, vagem)",
          "Gergelim para decorar",
        ],
        instructions: [
          "Corte o tofu em cubos e marine no molho teriyaki.",
          "Grelhe o tofu até dourar.",
          "Cozinhe os legumes no vapor.",
          "Monte o bowl com arroz, tofu e legumes. Decore com gergelim.",
        ],
        prepTime: "30 minutos",
      }
  ];